import type { SpotlightFeedback } from '../../customer-spotlights/spotlights.types';

export enum AffectedProductStatus {
  PATCHED = 'patched',
  NOT_APPLICABLE = 'not_applicable',
  UNPATCHED = 'unpatched',
  SUBMIT_FOR_REVIEW = 'submit_for_review',
  DECLINED = 'declined',
}

export interface SpotlightProduct {
  id: string;
  name: string;
  affectedVersion?: string | null;
  customerVersion?: string | null;
  status?: AffectedProductStatus | null;
  statusReason?: string | null;
  declinedAt?: number | null;
  declinedReason?: string | null;
  customerSpotlightFeedback?: SpotlightFeedback;
}

export enum SpotlightStatus {
  PATCHED = 'patched',
  PARTIALLY_PATCHED = 'partially_patched',
  UNPATCHED = 'unpatched',
  NOT_APPLICABLE = 'not_applicable',
}

export interface SpotlightInsight {
  spotlightName: string;
  reasonName: string;
  reasonDescription: string;
  dataSource: string;
  accountId?: string;
  cve: string[];
  vendorAdvisoryLinks?: string[];
  mostImpactedCF: string;
  importance: string;
  created: string;
  status?: SpotlightStatus;
  products?: SpotlightProduct[] | null;
}

export interface RowState {
  customerVersion: string;
  status?: AffectedProductStatus;
  baselineStatus?: AffectedProductStatus;
  isDirty?: boolean;
  holdAttempts?: number;
}

export interface SpotlightDetailsPersonaForNavigation {
  isCowbell: boolean;
  isInsured: boolean;
  basePath: string;
}

export const SAVE_API_ERROR_TITLE = "Couldn't save your update";
export const SAVE_API_ERROR_BODY =
  'A temporary problem prevented us from saving. Try again in a moment. If this keeps happening, contact support.';

export enum ActiveTab {
  SPOTLIGHT = 'spotlight',
  INSIGHTS = 'insights',
  INFORMATION = 'information',
}

export enum TableId {
  REASONS_RECOMMENDATIONS_SPOTLIGHT = 'reasonsRecommendationsSpotlight',
  REASONS_RECOMMENDATIONS_INSIGHTS = 'reasonsRecommendationsInsights',
  REASONS_RECOMMENDATIONS_INFORMATION = 'reasonsRecommendationsInformation',
}
